import {Pipe, PipeTransform} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {SharedStoreFacade} from 'app/main/shared/shared/store/shared-store.facade';
import moment from 'moment-timezone';
import {filter, map, Observable, take} from 'rxjs';


enum ReturnType {
    Class = 'class',
    Status = 'status'
}

@Pipe({ name: 'todoStatusBadge' })

export class TodoStatusBadgePipe implements PipeTransform {
    constructor (
        private _sharedStoreFacade$: SharedStoreFacade,
        private _translocoService$: TranslocoService
    ){}

    transform(due_date: string, returnType: ReturnType): Observable<string> {
        return this._sharedStoreFacade$.userTimezone$.pipe(
            filter(timeZone => Object.keys(timeZone)?.length > 0),
            take(1),
            map(userTimezone => {
                const currentDate = moment.tz(new Date(), userTimezone?.timezone).format('YYYY-MM-DD');
                const dueDate = moment.tz(due_date, userTimezone?.timezone).format('YYYY-MM-DD');
                return this.statusEvent(dueDate, currentDate, returnType);
            })
        );
    }



    private statusEvent(dueDate: string, currentDate: string, returnType: ReturnType){
        const due = new Date(dueDate);
        const curr = new Date(currentDate);
        if (due < curr) {
            return returnType === ReturnType.Class ? 'danger' : this._translocoService$.translate('Delayed task and reminders widget text - (Dashboard section) - Delayed');
        } else if (due.toDateString() === curr.toDateString()) {
            return returnType === ReturnType.Class ? 'success' : this._translocoService$.translate('Today task and reminders widget text - (Dashboard section) - Today');
        } else {
            return returnType === ReturnType.Class ? 'secondary' : this._translocoService$.translate('Upcoming task and reminders widget text - (Dashboard section) - Upcoming');
        }
    }

}
